import React, {useState, useEffect} from 'react'
import {LoadEffect}  from '../component/loader'
import axios from 'axios'
import { Alerts} from '../component/notify'
import PageHeader from '../component/pageheader'
import {Currency, FormatNumber, ImagesUrl, ServerUrl, API_URL, Token, config} from '../component/include'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import {  longDate} from '../component/globalFunction'
import { userToken } from '../component/authentication'

const AccountStatement =()=> {
    const [errors, setErrors] = useState({});
    const schoolInfo  = useSelector(state => state.rootReducer.schoolInfo);
    const [account, setAccount]=useState([])

    const [result, setResult] = useState([])
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    }); 
    
    const [statement, setStatement] = useState({
       account:[],
       fromDate:'',
        toDate:'',
        credit:0,
        debit:0,
        balance:0
    })

 

    const fetchAccount=()=>{
      
        setNotice({...notice, isLoading: true}) 
        let url = API_URL+'/finance/account/balance'
        axios.get(url,  config).then(result=> setAccount(result.data.data))
        .catch((error)=>{
        Alerts('Error!', 'danger', error.message)
        }).finally(()=>{
        setNotice({...notice, isDataFetching: false})

        })  
    }

      
        const handleSelect= (option, action)=>{
            setStatement({...statement, [action.name]:option, balance:option.balanc});
            setErrors({...errors, [action.name]:''})
            setResult('')
        }

        const handleChange=(event)=>{
            const {name, value} = event.target;
            setStatement({...statement, [name]:value})
            setErrors({...errors, [name]:''})
            setResult('')
            
        }
    
            const fetchResult =()=>{
                 if(statement.account.length===0){
                    setErrors({...errors, account:'Please select account'})
                }else if(!statement.fromDate){
                    setErrors({...errors, fromDate:'Please select from date'})
                }else if(!statement.toDate){
                    setErrors({...errors, toDate:'Please select to date'})
                } else{ 
                
    
  setNotice({...notice, isLoading: true}) 
  const fd = new FormData();
   fd.append("account", statement.account.value); 
   fd.append("fromDate", statement.fromDate); 
   fd.append("toDate", statement.toDate); 

            let url = API_URL+'/finance/account/all'
            axios.post(url, fd, config).then(result=>{
   
                if(result.data.data.length!==0){
                    var credit = 0, debit = 0;
                    result.data.data.map(data=>data.type==='debit'?debit+=Number(data.amount):credit+=Number(data.amount))
                    setResult(result.data.data)
                    setStatement({...statement, debit:debit, credit:credit})
                }else{
                    Alerts('Info!', 'default', 'No record found for the selected criterials')
                }
                
            })
            .catch((error)=>{
            Alerts('Error!', 'danger', error.message)
            }).finally(()=>{
                setNotice({...notice, isLoading: false})
                
            })   
        } 
            }
    
     
     useEffect(()=>{
        fetchAccount()
    },[]);


        return (  
   <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Account Statement">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-money"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Finance</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Account Statement</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">

                <div className="row  ">
						
                        <div className="col-sm-12">
                    
                        <div className="card z-depth-0">
                            <div className="card-header">
                                <h5><i className="fa fa-edit" ></i> Account Statement</h5>
                                <div className="card-header-right">
                                    <ul className="list-unstyled card-option">
                                        <li><i className="feather icon-maximizes full-card"></i></li>
                                        <li><i className="feather icon-minus minimize-card"></i></li>
                                        <li><i className="feather icon-trash-2 close-card"></i></li>
                                    </ul>
                                </div>
                            </div>
                            
                            
                            <div className="card-block">
        
        <div  className="card-block">
        <div  className="card z-depth-0" >

		<div  className="card-block">
		
        <div className="row">
        <section className="col-md-6">
            <div className="form-group">
						<label >Account <span style={{color:'red'}}>*</span> </label>
						<Select options={
                             account&&account.map((list, idx)=> {
                                return {key:idx, value: list.code, label: list.accountName, balance:list.openingBalance, balanceOpen:list.balanceOpen}
                             })} 
                             getOptionLabel={option =>` ${option.label} Balance: ${Currency+FormatNumber(option.balance)}`}
onChange={handleSelect} className={errors.account? 'form-control form-control-danger' : ''} name="account" value={statement.account}  /> <span style={{color:'red'}}>{errors.account && errors.account}</span>
										  </div>

      </section>
      
      <section className="col-md-3">
      <div className="form-group">
   <label >From Date <span style={{color:'red'}}>*</span></label>
   <input type="date" className={errors.fromDate ? 'form-control form-control-danger' : 'form-control'} name="fromDate"   onChange={handleChange} value={statement.fromDate} />

   <span style={{color:'red'}}>{errors.fromDate && errors.fromDate}</span>
               </div>

   

</section>
      <section className="col-md-3">
      <div className="form-group">
   <label >To Date <span style={{color:'red'}}>*</span></label>
   <input type="date" className={errors.toDate ? 'form-control form-control-danger' : 'form-control'} name="toDate"   onChange={handleChange} value={statement.toDate} />

   <span style={{color:'red'}}>{errors.toDate && errors.toDate}</span>
               </div>

</section>	
      


				</div>	

<div className="row" >
<section className="col-md-12">
	<footer className="pull-right">
	
	<button type="button" id="submit" onClick={()=>fetchResult()} className="btn btn-primary "><i className="fa fa-search"></i> Search</button>
								</footer>		</section>		
                                </div>
                            
                            
                            </div></div> 
							</div></div>
</div>
</div>
</div>



{result.length!==0?
    <div className="card z-depth-0">
		<div className="card-block">
	
       	
{schoolInfo&&schoolInfo.map((st, id)=>
               <div className="row" key={id}>

<table className="table  table-full-width">
<tbody>
<tr>
<td className="text-center" ><img id="viewSchoolLogo2" className="img-100" onError={(e)=>{e.target.onerror = null; e.target.src=ImagesUrl+'/logo.png'}} src={`${ImagesUrl}/about/${st.schoolLogo}`}  title="School Logo" alt=''  />
<h4 style={{textAlign:'center'}}><b>{st.schoolName}</b></h4>
<h6 style={{textAlign:'center'}}><b>Motto: {st.schoolMotto}</b></h6>
<div style={{textAlign:'center'}}>  {st.address}  </div>
<div style={{textAlign:'center'}}> {st.mobile}, {st.altMobile}, {st.email} </div>

<div style={{textAlign:'center'}}>  Website: {st.website}  </div>
</td>
        </tr>
    </tbody>
</table>

</div> 
               )}
 <div className="row">
        <div className="col-md-12">
        <h5 style={{textAlign:'center'}}><u><b>STATEMENT OF ACCOUNT </b></u></h5>
        </div></div><br/>



<div className="row">
<div className="col-md-12 table-responsive">

       <table className="table table-bordered  table-full-width">
       <tbody>
                <tr>
                    <td >Account: <br/><b>{statement.account.value+' - ' +statement.account.label}</b></td>
                    <td >Date Range: From <br/><b>{longDate(statement.fromDate)+ ' to '+ longDate(statement.toDate)}</b></td>
                    <td >Current Balance: <br/> <b>{Currency+FormatNumber(statement.account.balance)}</b></td>
                </tr>
            </tbody>
       </table>
       <table className="table table-striped table-bordered">
        <thead>
                <tr>
                <th>S/N</th>
                <th>Txn Date</th>
                    <th>Description</th>
                    <th>Debit ({Currency})</th>
                    <th>Credit ({Currency})</th>
                </tr>
              </thead>
              <tbody>
              {result.length!==0?result.map((st, idx)=> 
                <tr key={idx}>
                <td>{idx+1}</td>
                <td>{longDate(st.incomeDate)}</td>
                <td>{st.headName+' '+st.remarks}</td>
                <td>{st.type==='debit'?FormatNumber(st.amount):''}</td>
                <td>{st.type==='credit'?FormatNumber(st.amount):''}</td>
                </tr>):[]}
              </tbody>
            <tfoot>
                <tr>
                <th colSpan='3'>Account: <b></b></th>
                    <th>Total Debit: <b>{Currency+FormatNumber(statement.debit)}</b></th>
                    <th>Total Credit: <b>{Currency+FormatNumber(statement.credit)}</b></th>
                </tr>
            </tfoot>

        </table>
 </div>	 </div> 

 <div className="row">
        <div className="col-md-12">
        <form method='POST' action={ServerUrl+'/printout/account_statement.php?token='+userToken} target='_blank'>
                <input type='hidden' name='result' value ={JSON.stringify(result, null, 2)} />
                <input type='hidden' name='account' value ={statement.account.value+' - ' +statement.account.label} />
                <input type='hidden' name='jwtToken' value ={Token} />
                <input type='hidden' name='debit' value ={statement.debit} />
                <input type='hidden' name='credit' value ={statement.credit} />
                
                <input type='hidden' name='balanceOpen' value ={statement.balance} />
                <input type='hidden' name='balance' value ={statement.account.balance} />
                <input type='hidden' name='dateRange' value ={longDate(statement.fromDate)+ ' to '+ longDate(statement.toDate)} />
        <button type="submit" className="btn btn-inverse pull-right no-print" > <i className="fa fa-print"></i> Print</button>
        
        </form>
        </div></div>

 </div>
        </div>:''}



   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
 );
        
}

export default React.memo(AccountStatement) 